'use strict';
import angular from 'angular';
import './exportbuilder.header.components';

angular.module('exportbuilder.header', [
    'exportbuilder.header.components'
]);